import type { ReactElement } from 'react';
import React from 'react';
import { NotificationList } from 'feature-components/notification';
import MainLayout from 'layouts/main';
import { useNotifications } from 'services/assist-api/entities/notification/check';

export default function NotificationsPage(): ReactElement {
  const notifications = useNotifications({ filters: { location: 'notification_centre' } });

  return (
    <MainLayout size="lg" title="Notifications">
      <NotificationList notifications={notifications.data?.json} />
    </MainLayout>
  );
}
